import React from 'react';
import { Icon } from 'antd'
import './siteLogo.css';

export const SiteLogo = () => (
  <Icon className="site-logo"/>
);



// WEBPACK FOOTER //
// ./src/components/common/siteLogo/siteLogo.js